export default __webpack_public_path__ + "static/media/FICHA TÉCNICA- MELÃO PELE DE SAPO.2249d59b.pdf";